import AbstractComponent from "./abstract-component";


const createTemplate = () => {
  // const currentDate = new Date().toISOString().slice(0, 10);

  return (
    `<article class="orderSpec">
      <div class="orderSpec__inputWrap">
        <p class="orderSpec__input input-placeholder">
          <input class="js--passwordInput" type="text" placeholder=" " name="title" id="title" autocomplete="off">
          <label>Наименование</label>
        </p>
        <p class="orderSpec__input input-placeholder">
          <input class="js--passwordInput" type="number" placeholder=" " name="buy" id="buy" autocomplete="off">
          <label>Закуп, ₽</label>
        </p>
        <p class="orderSpec__input input-placeholder">
          <input class="js--passwordInput" type="number" placeholder=" " name="sell" id="sell" autocomplete="off">
          <label>Продажа, ₽</label>
        </p>
        <p class="orderSpec__input input-placeholder">
          <input class="js--passwordInput" type="text" placeholder=" " name="link" id="link" autocomplete="off">
          <label>Ссылка</label>
        </p>
        <p class="orderSpec__input input-placeholder">
          <input class="js--passwordInput" type="date" placeholder=" " name="date" id="date" autocomplete="off">
          <label>Дата доставки</label>
        </p>
      </div>
      <div class="orderSpec__buttonWrap" data-mode="button">
        <button class="orderSpec__button button-primary js--addButton" type="button" data-disabled="false">Добавить</button>
        <div class="modal__progress">
          <img src="/sienge/img/load_bar.gif" alt="">
        </div>
      </div>
    </article>`
  );
};

export default class SpecOrderTileComponent extends AbstractComponent {
  constructor() {
    super();
    this._onInputHandler();
    // this._onClearButtonClickHandler();
  }

  getTemplate() {
    return createTemplate();
  }

  setAddButtonClickHandler(handler) {
    this.getElement().querySelector(`.js--addButton`).addEventListener(`click`, () => {
      if (!this._getIsValid()) {
        return;
      }
      this.getElement().querySelector(`.orderSpec__buttonWrap`).dataset.mode = `progress`;

      handler({
        title: this.getElement().querySelector(`input[name="title"]`).value,
        buy: this.getElement().querySelector(`input[name="buy"]`).value,
        sell: this.getElement().querySelector(`input[name="sell"]`).value,
        link: this.getElement().querySelector(`input[name="link"]`).value,
        date: this.getElement().querySelector(`input[name="date"]`).value,
      }, () => {
        this.getElement().querySelector(`.orderSpec__buttonWrap`).dataset.mode = `button`;
      });
    });
  }

  // _onClearButtonClickHandler() {
  //   const clearButtons = this.getElement().querySelectorAll(`.js--clearButton`);

  //   Array.from(clearButtons).forEach((button) => {
  //     button.addEventListener(`click`, () => {
  //       const name = button.dataset.name;
  //       this.getElement().querySelector(`input[name="${name}"]`).value = ``;
  //       button.dataset.show = `false`;

  //       this.getElement().querySelector(`.js--addButton`).dataset.disabled = !this._getIsValid();
  //     });
  //   });
  // }

  _onInputHandler() {
    const inputs = this.getElement().querySelectorAll(`input`);

    Array.from(inputs).forEach((input) => {
      input.addEventListener(`input`, (evt) => {
        // const inputElement = evt.target;

        // const name = inputElement.name;
        // const value = inputElement.value;
        // this.getElement().querySelector(`.js--clearButton[data-name="${name}"]`).dataset.show = !!value;

        this.getElement().querySelector(`.js--addButton`).dataset.disabled = !this._getIsValid();
      });
    });
  }

  _getIsValid() {
    return true;
    // return !!this.getElement().querySelector(`input[name="title"]`).value &&
    //   !!this.getElement().querySelector(`input[name="buy"]`).value &&
    //   !!this.getElement().querySelector(`input[name="sell"]`).value &&
    //   !!this.getElement().querySelector(`input[name="link"]`).value &&
    //   !!this.getElement().querySelector(`input[name="date"]`).value;
  }
}
